import { ReminderPreferencesTable } from "components";

const ReminderPreferences = () => {
    return (
        <ReminderPreferencesTable />
    );
}

export default ReminderPreferences;
